'use client';

import { LoginScreen } from '@dh/screens/login/LoginScreen';

export default function Login() {
    return <LoginScreen />;
}
